export interface EventItem {
  name: string;
  eventKey: string;
  eventType: EventType;
  extended?: boolean;
}

export enum EventKey {
  SessionState = 'SessionState',
  SessionEvent = 'SessionEvent',
  SessionOverviewEvent = 'SessionOverviewEvent',
  Bitrate = 'Bitrate',
  Framerate = 'Framerate',
  ConnectionType = 'ConnectionType',
  CDN = 'CDN',
  Asset = 'AssetName',
  Error = 'Error',
  CustomEvent = 'CustomEvent',
}

export enum EventType {
  stateTimeline = 'stateTimeline',
  linearTimeline = 'linearTimeline',
  eventTimeline = 'eventTimeline',
}

export interface StateDataType {
  startTimeMs: number;
  endTimeMs: number;
  value: string;
}

export interface EventDataType {
  timeMs: number;
  value: any;
}

export interface LinearDataType {
  startTimeMs: number;
  endTimeMs: number;
  startValue: string;
  endValue: string;
}
